<template>
  <div>
    <LessonDetailModal
      :isOpen="isOpen"
      :close="close"
      :lesson="selectedLesson"
      :reload="reload"
      v-if="isOpen"
    />
    <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
      <b-row class="my-4 min-width-full align-items-center">
        <b-col md="4">
          <b-input-group>
            <b-form-input
              id="inline-form-input-name"
              class=" mr-sm-2 md-4"
              placeholder="수업명을 입력하세요."
              v-model="search.title"
              v-on:keyup.enter="handleSearch"
            ></b-form-input>
            <b-input-group-append>
              <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table :fields="fields" :items="lessons" class="text-left">
        <template #cell(button)="data">
          <div class="text-right">
            <button class="btn btn-warning text-white" @click="openModal(data.item)">상세</button>
          </div>
        </template>
      </b-table>
      <b-pagination
        align="center"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="pageSize"
        @page-click="changePage"
      />
    </div>
  </div>
</template>
<script>
import api from "@/api/api";
import LessonDetailModal from "@/components/modals/LessonDetailModal.vue";

export default {
  components: {LessonDetailModal},
  data() {
    return {
      searchLessons: [],
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      isOpen: false,
      selectedLesson: {},
      fields: [
        {
          label: '강의명',
          key: 'title',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "20%" },
        }
      ],
      search: {
        title: "",
        checkDeleted: false
      },
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.title = query.keyword
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    close() {
      this.isOpen = !this.isOpen
    },
    openModal(lesson) {
      this.selectedLesson = lesson
      this.isOpen = !this.isOpen
    },
    modalClose(){
      this.isOpen = !this.isOpen
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.title) {
        query.keyword = this.search.title
      }
      
      this.$router.replace({ query })
    },
    getPagingList(page) {
      let param = {
        page: page,
        keyword: this.search.title,
      }
      
      api.lesson.searchLessons(param,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.lessons = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.text-right{
  text-align: right;
}
</style>